import { useCycle } from "framer-motion";
import { useRef } from "react";

import { useDimensions, useClickAway } from "global/hooks";

const useSidebar = () => {
  const [isOpen, toggleOpen] = useCycle(false, true);
  const containerRef = useRef(null);
  const { height } = useDimensions(containerRef);

  const clickAwayRef = useClickAway(() => {
    isOpen && toggleOpen();
  });

  return { isOpen, toggleOpen, height, clickAwayRef };
};

export default useSidebar;
